<template>
  <div class="box_rank your_leader">
    <h3>{{ $_translations.value.page_leaderboard_section_users_title }}</h3>

    <template v-if="!loading">
      <slot></slot>

      <a
        v-if="hasExpandButton && !expanded"
        href="#"
        class="load-more"
        @click.prevent="$emit('load:all')"
      >
        <i class="fas fa-chevron-down"></i>
      </a>
    </template>
  </div>
</template>

<script setup>
defineEmits(['load:all']);

defineProps({
  hasExpandButton: {
    type: Boolean,
    default: false,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>
